import { noUndefined, ValueTransformer } from '@angular/compiler/src/util';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CategoryService } from 'src/app/_services/category.service';
import { ExternalConnectionService } from 'src/app/_services/externalConn.service';
import { RulesService } from 'src/app/_services/rules.services';

@Component({
  selector: 'app-rules-config',
  templateUrl: './rules-config.component.html',
  styleUrls: ['./rules-config.component.scss'],
})
export class RulesConfigComponent implements OnInit {
  noRule: boolean = true;
  eventNames: string[] = ['Upload', 'Update', 'Delete'];
  allCategories: any;
  categoryID: number;
  categoryProperties: string[];
  searchCtrl: string;
  button: string;
  ruleForm: FormGroup;
  allRules: any;
  selectedRule = {};
  displayedColumns = ['name', 'event', 'category', 'exid', 'actions'];
  tableDataSource: MatTableDataSource<any>;
  allExternalConnections: any;
  ruleId: number;
  isEditable: boolean = true;
  mergedArray: Array<JSON> = [];

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.tableDataSource.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.tableDataSource.paginator = this.paginator;
    }
  }

  constructor(
    private categoryService: CategoryService,
    private rulesService: RulesService,
    private externalConnService: ExternalConnectionService,
    private changeRefDedector: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.getCategories();
    this.getAllRules();
    this.createNewAttributeForm();
    this.getAllExternalConnections();
  }

  ngAfterContentChecked() {
    this.changeRefDedector.detectChanges();
  }

  getCategories() {
    this.categoryService.getAll().subscribe((response) => {
      this.allCategories = response;
      for (let i = 0; i < this.allRules.length; i++) {
        for (let j = 0; j < this.allCategories.results.length; j++) {
          if (
            this.allCategories.results[j].id == this.allRules[i].category_id
          ) {
            this.allRules[i]['category'] = this.allCategories.results[j].name;
          }
        }
      }
    });
  }

  getAllRules() {
    this.rulesService.getAllRules().subscribe((allRules) => {
      this.allRules = allRules;
      let activeRules = [];
      for (let i = 0; i < this.allRules.length; i++) {
        if (this.allRules[i].active) {
          activeRules.push(this.allRules[i]);
        }
      }
      this.tableDataSource = new MatTableDataSource(activeRules);
      this.tableDataSource.sort = this.sort;
      this.tableDataSource.paginator = this.paginator;
      this.tableDataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'name':
            return <string>item.rule_name;
          case 'event':
            return <string>item.event_name;
          case 'category':
            return <string>item.category;
          case 'exid':
            return <string>item['action_item']['exid'];
          default:
            return item[property];
        }
      };
    });
  }

  getAllExternalConnections() {
    this.externalConnService
      .getAllExternalConnections()
      .subscribe((allExtConns) => {
        this.allExternalConnections = allExtConns;
      });
  }

  createNewAttributeForm() {
    this.ruleForm = new FormGroup({
      name: new FormControl(''),
      eventName: new FormControl(''),
      categoryId: new FormControl(''),
      attributeValues: new FormArray([this.initAttributeValues()]),
      externalId: new FormControl(''),
    });
  }

  initAttributeValues() {
    return new FormGroup({
      attribute: new FormControl(''),
      value: new FormControl(''),
    });
  }

  addAttributeValue() {
    const control = <FormArray>this.ruleForm.get('attributeValues');
    control.push(this.initAttributeValues());
  }

  getAttributeValue(form) {
    return form.controls.attributeValues.controls;
  }

  deleteAttributeValue(index: number) {
    this.formArray.removeAt(index);
  }

  get formArray() {
    return <FormArray>this.ruleForm.get('attributeValues');
  }

  save() {
    var formObject = Object.assign(this.ruleForm.value);
    var attributesArray = [];
    var attributes = {};
    var values: string[] = [];
    this.categoryProperties.forEach((property) => {
      values = [];
      attributes = {};
      formObject.attributeValues.forEach((attributeValue) => {
        if (attributeValue.attribute == property) {
          values.push(attributeValue.value);
        }
      });
      if (values.length > 0) {
        attributes['name'] = property;
        attributes['values'] = values;
        attributesArray.push(attributes);
      }
    });
    var payload = {
      name: formObject.name,
      event: formObject.eventName,
      category_id: parseInt(formObject.categoryId),
      attributes: attributesArray,
      action: {
        exid: parseInt(formObject.externalId),
      },
    };
    this.rulesService.createUpdateRule(payload, this.ruleId).subscribe(
      (data) => {
        this.getAllRules();
        this.ruleId = null;
        this.noRule = true;
      },
      (error) => {
        console.log('ERROR WHILE UPDATING', error);
      }
    );
  }

  getCategoryProperties(categoryId) {
    this.categoryProperties = [];
    for (let category of this.allCategories.results) {
      if (category.id == categoryId) {
        for (let metaData of category.meta_data_definition) {
          if (metaData.active) {
            for (let property of metaData.properties) {
              this.categoryProperties.push(property.name);
            }
          }
        }
      }
    }
    this.categoryProperties = this.categoryProperties.filter((elem, i, arr) => {
      if (arr.indexOf(elem) === i) {
        return elem;
      }
    });
  }

  setSelectedRuleForm() {
    this.createNewAttributeForm();
    this.isEditable = false;
    this.ruleId = this.selectedRule['rule_id'];
    this.categoryID = this.selectedRule['category_id'];
    this.getCategoryProperties(this.categoryID);
    var totalPairs = 0;
    var data = {
      name: this.selectedRule['rule_name'],
      eventName: this.selectedRule['event_name'],
      categoryId: this.selectedRule['category_id'],
      attributeValues: [],
      externalId: this.selectedRule['action_item']['exid'],
    };
    this.selectedRule['attributes_value'].forEach((element) => {
      totalPairs = totalPairs + element['values'].length;
      element['values'].forEach((value) => {
        this.addAttributeValue();
        var obj = {};
        (obj['attribute'] = element.name), (obj['value'] = value);
        data.attributeValues.push(Object.assign({}, obj));
      });
    });
    this.deleteAttributeValue(totalPairs - 1);
    this.ruleForm.patchValue(data);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.tableDataSource.filter = filterValue.trim().toLowerCase();

    if (this.tableDataSource.paginator) {
      this.tableDataSource.paginator.firstPage();
    }
  }

  newRule() {
    this.ruleId = null;
    this.noRule = false;
    this.categoryProperties = [];
    this.categoryID = null;
    this.createNewAttributeForm();
    this.button = 'Save';
    this.isEditable = true;
  }

  back() {
    this.noRule = true;
  }

  updateRule(rule) {
    this.selectedRule = rule;
    this.button = 'Update';
    this.setSelectedRuleForm();
    this.noRule = false;
  }

  deleteRule(rule) {
    this.rulesService.deleteRule(rule['rule_id']).subscribe((resp) => {
      this.getAllRules();
    });
  }
}
